import { Stack } from "@mui/system";
import Loading from "../../componentes/loading";

export const LoadingPage = () => {
  return (
    <Stack
      width="100%"
      height={"calc(100vh - 64px)"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Loading size={150} />{" "}
    </Stack>
  );
};
